import React, { useRef, useEffect } from "react";

const Modal = ({
  isOpen,
  onClose,
  children,
  overlayClassName = "bg-black/40",
  contentClassName = "max-w-3xl",
}) => {
  const modalRef = useRef(null);

  // Close when clicking outside the modal content
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        // onClose(); // Call the onClose prop instead of internal state
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {isOpen && (
        <div
          className={`fixed inset-0 z-[9999] flex items-center justify-center px-4 py-6 ${overlayClassName}`}
        >
          <div
            ref={modalRef}
            role="dialog"
            aria-modal="true"
            className={`relative w-full overflow-hidden rounded-[10px] border border-slate-200 bg-white shadow-[0_35px_90px_rgba(15,23,42,0.25)] ${contentClassName}`}
          >
            {children}

            <button
              type="button"
              onClick={onClose}
              className="absolute top-4 right-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-xl text-slate-600 transition hover:bg-slate-200 hover:text-slate-900"
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
